import React from 'react';
import Relay from 'react-relay';
import { style } from 'glamor';
import Helmet from 'react-helmet';
import NestedStatus from 'depop/components/NestedStatus';

import Application from 'depop/root/containers/Application';

import { ScrollTop } from 'depop/components/scroll';

import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'NotFound.title',
    defaultMessage: 'Page Not Found',
    description: 'Title tag for missing pages',
  },
  appLinkText: {
    id: 'NotFound.messageAppLinkText',
    defaultMessage: 'use the app instead',
    description: 'Text for the link embedded in the not found message',
  },
});

type Props = {
  intl: Object,
  viewer: Object,
};

const NotFound = ({intl, viewer}: Props) => {
  return (
    <Application viewer={viewer}>
      <div {...style({height: '70vh', display: 'flex', flexDirection: 'column', justifyContent: 'center'})}>
        <ScrollTop />
        <Helmet
          title={intl.formatMessage(messages.title)}
          meta={[
            { name: 'robots', content: 'noindex' },
          ]}
          link={[
            {
              rel: 'canonical',
              href: 'https://www.depop.com/not-found'
            }
          ]}
        />
        <NestedStatus code={404} />
        <h1 {...style({fontWeight: 'normal', fontSize: '24px', marginBottom: '1em'})}>
          <FormattedMessage
            id="NotFound.message"
            description="Message on the not found page"
            defaultMessage="Sorry, that page doesn't exist. Try again or {link}"
            values={{
              link: <a {...style({color: 'inherit', fontWeight: 'bold'})} href="https://depop-beta.app.link/F5P0iUMdUw">
                {intl.formatMessage(messages.appLinkText)}
              </a>,
            }} />
        </h1>
        <p {...style({fontSize: '14px'})}>
          <FormattedMessage
            id="NotFound.smallMessage"
            description="Small status code message on not found page"
            defaultMessage="404 page not found" /></p>
      </div>
    </Application>
  );
};

export default Relay.createContainer(injectIntl(NotFound), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${Application.getFragment('viewer')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/views/NotFound.js